import { Pipe, PipeTransform } from '@angular/core';
import {ChartService} from '../services/sp-chart/chart.service';

@Pipe({name: 'numberFormat'})
export class NumberFormatPipe implements PipeTransform {
  transform(value: number): string {
    return ChartService.separator(value);
  }
}
